import { CheckRecord } from "./CheckRecord";
import { OrderTypeSummaries } from "./OrderTypeSummaries";
import { Store } from "./Store";
import { StoreCheckRecord } from "./StoreCheckRecord";

export class OrderType {
	venueKey: number;
	ID: number;
	Name: string;
	FlagTipped: boolean;

	Tipped: string;

	Checks: CheckRecord[];

	OrderTypeSummaries: OrderTypeSummaries[];

	StoreCheckRecord: StoreCheckRecord[];

	stores: Store;

	public constructor(init?: Partial<OrderType>) {
		Object.assign(this, init);
	}
}
